import {debug, error, info, warn} from './logger';

export default {
    debug,
    info,
    warn,
    error
};

export type {LoggingContext} from "./logger";